import React from 'react';
import styled from 'styled-components';
import { COLOR } from '../../constants/common';

const SpinnerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ mh }) => mh || '50vh'};
`;

export const Spinner = ({ color, mh }) => (
  <SpinnerWrapper mh={mh}>
    <StyledSpinner viewBox="0 0 50 50" color={color}>
      <circle cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
    </StyledSpinner>
  </SpinnerWrapper>
);

const StyledSpinner = styled.svg`
  animation: rotate 2s linear infinite;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;

  circle {
    stroke: ${({ color }) => color || COLOR.yellowishOrange};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
      circle {
        stroke: ${({ color }) => color || COLOR.yellowishOrange};
      }
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
      circle {
        stroke: #bf1e21;
      }
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
      circle {
        stroke: #27bf55;
      }
    }
  }
`;
